import React, { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import Input from '../../components/Input';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import styles from '../../styles/forms/planning_library_item/PlanningLibraryItemForm.scss';

@reduxForm({
  form: 'company_tag',
  enableReinitialize: true,
})
class CompanyTagForm extends Component {
  render() {
    return (
      <Form className={styles.wrapper} onSubmit={this.props.handleSubmit}>
        <header className={styles.header}>
          <span className={styles.title}>
            {this.props.editing
              ? __('company-tags.editor.title', {}, 'Edit tag')
              : __('company-tags.editor.create-title', {}, 'Create tag')}
          </span>
          <span className={styles.subtitle}>
            {this.props.editing
              ? __(
                  'company-tags.editor.subtitle',
                  {},
                  'The tag will be renamed on all active company projects.',
                )
              : __(
                  'company-tags.editor.create-subtitle',
                  {},
                  'The tag will be available on all company projects.',
                )}
          </span>
        </header>

        <div className={styles.form}>
          <Field
            name='name'
            component={Input}
            label={__('company-tags.editor.name', {}, 'Name')}
            maxLength={255}
          />
        </div>

        <footer className={styles.footer}>
          <Button
            lightGray
            medium
            middleText={__('button.cancel')}
            onClick={this.props.onClose}
          />
          <ButtonGroup>
            <Button
              submit
              lightBlue
              medium
              middleText={
                this.props.editing ? __('button.save') : __('button.create')
              }
              spinning={this.props.submitting}
            />
          </ButtonGroup>
        </footer>
      </Form>
    );
  }
}

export default CompanyTagForm;
